'use client';

import { useAtomValue } from 'jotai';
import { usePathname, useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { useEffect } from 'react';

import { ensureAnalyticsInitialized, initAnalytics } from '@/lib/analytics';
import currentUserAtom from '@/stores/atoms/currentUserAtom';

const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

const pageview = (url: string) => {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'pageview',
      page: url,
    });
  }
};

export default function Analytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const currentUser = useAtomValue(currentUserAtom);

  useEffect(() => {
    if (pathname) {
      pageview(pathname);
    }

    // SDK の匿名初期化を先行実行する。
    // Mixpanel は init 前に track すると例外になるため、ログイン前に発火する
    // 認証イベント等に備えてユーザー確定を待たずに初期化しておく。
    ensureAnalyticsInitialized();

    // ユーザーが確定していれば識別まで行う（ファサード側で二重実行を防止）。
    if (currentUser?.id) {
      initAnalytics(currentUser);
    }
  }, [pathname, searchParams, currentUser]);

  if (!GTM_ID) return null;

  return (
    <>
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_ID}');
        `,
        }}
      />
    </>
  );
}
